(ns practitest.dev.utils
  #?(:cljs (:require-macros [practitest.dev.utils]))
  #?(:clj (:require [clojure.string :as str])
     :cljs (:require
             [cljs.pprint :refer [pprint]]
             ["highlight.js/lib/core" :as hl]
             ["highlight.js/lib/languages/clojure" :as hl-clojure]
             [reagent.core :as reagent]
             [reagent.dom])))

#?(:cljs
   (hl/registerLanguage "clojure" hl-clojure))

#?(:cljs
   (defn debug-output
     [obj]
     (let [local-state (reagent/atom {})]
       (reagent/create-class
         {:display-name         "debug-output"
          :component-did-mount  (fn [comp]
                                  (when-let [code (.querySelector (reagent.dom/dom-node comp) "code")]
                                    (hl/highlightElement code)))
          :component-did-update (fn [comp old-argv]
                                  (when-let [code (.querySelector (reagent.dom/dom-node comp) "code")]
                                    (hl/highlightElement code)))
          :reagent-render       (fn [obj]
                                  (let [show? (get @local-state :show?)]
                                    [:div
                                     [:button.m-button.m-primary-button
                                      {:tab-index -1
                                       :on-click  (fn [e]
                                                    (swap! local-state update :show? not))}
                                      (if show?
                                        "Hide"
                                        "Show")]
                                     (when show?
                                       [:pre
                                        [:code.language-clojure
                                         (with-out-str
                                           (cljs.pprint/pprint obj))]])]))}))))
